import React from "react";

const NoDataScreen = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3621_2)">
      <rect x="4" y="4" width="24" height="24" rx="4" fill="#EDEEFF" />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.6429 19.7904V17.8704C21.6429 17.7289 21.5284 17.6144 21.387 17.6144H18.059V17.1024C18.059 16.8988 17.9781 16.7034 17.8341 16.5593C17.69 16.4153 17.4946 16.3344 17.2909 16.3344L17.035 16.3341V15.0544H17.5469C17.6883 15.0544 17.8029 14.9398 17.8029 14.7984V13.7685C17.8029 13.2947 17.6148 12.8405 17.2798 12.5056C16.9448 12.1706 16.4906 11.9824 16.0168 11.9824H15.2429C15.1015 11.9824 14.9869 12.097 14.9869 12.2384V12.7504H11.6589C11.3194 12.7504 10.9938 12.8853 10.7538 13.1253C10.5138 13.3652 10.3789 13.6909 10.3789 14.0304V18.1264C10.3789 18.4658 10.5138 18.7914 10.7538 19.0314C10.9938 19.2714 11.3194 19.4064 11.6589 19.4064H21.1309V19.7904C21.1309 19.9317 21.2456 20.0464 21.3869 20.0464C21.5282 20.0464 21.6429 19.9317 21.6429 19.7904L21.6429 19.7904ZM18.0589 18.1263V18.6384C18.0589 18.7264 18.0438 18.8129 18.015 18.8944H18.3149V18.6384C18.3149 18.497 18.4296 18.3824 18.5709 18.3824C18.7122 18.3824 18.8269 18.4971 18.8269 18.6384V18.8944H19.3389V18.6384C19.3389 18.497 19.4536 18.3824 19.5949 18.3824C19.7362 18.3824 19.8509 18.4971 19.8509 18.6384V18.8944H20.3628V18.6384C20.3628 18.497 20.4776 18.3824 20.6189 18.3824C20.7602 18.3824 20.8749 18.4971 20.8749 18.6384V18.8944H21.1309V18.1263L18.0589 18.1263ZM11.6589 13.2623H15.7549C15.9586 13.2623 16.1539 13.3432 16.2981 13.4872C16.442 13.6314 16.5229 13.8266 16.5229 14.0303V16.3343C16.5229 16.4701 16.5768 16.6003 16.673 16.6963C16.769 16.7924 16.8991 16.8463 17.035 16.8463H17.2909C17.3588 16.8463 17.424 16.8733 17.4719 16.9213C17.52 16.9693 17.5469 17.0345 17.5469 17.1023V18.6383C17.5469 18.7062 17.5199 18.7713 17.4719 18.8193C17.424 18.8673 17.3588 18.8943 17.2909 18.8943H11.6589C11.4553 18.8943 11.2599 18.8134 11.1158 18.6694C10.9718 18.5253 10.8909 18.3299 10.8909 18.1262V14.0302C10.8909 13.8266 10.9718 13.6313 11.1158 13.4871C11.2599 13.3432 11.4553 13.2623 11.6589 13.2623L11.6589 13.2623ZM12.4269 18.1263H12.1349C11.8719 18.1263 11.659 17.9134 11.659 17.6506V17.3584C11.659 17.2171 11.5442 17.1024 11.4029 17.1024C11.2617 17.1024 11.1469 17.2171 11.1469 17.3584V17.6505C11.1469 18.1962 11.5892 18.6384 12.1349 18.6384H12.4269C12.5683 18.6384 12.6829 18.5237 12.6829 18.3824C12.6829 18.2411 12.5683 18.1264 12.4269 18.1264L12.4269 18.1263ZM13.7069 14.2863C12.7179 14.2863 11.9149 15.0893 11.9149 16.0784C11.9149 17.0674 12.7179 17.8703 13.7069 17.8703C14.696 17.8703 15.4989 17.0674 15.4989 16.0784C15.4989 15.0893 14.696 14.2863 13.7069 14.2863ZM13.7069 14.7984C14.4133 14.7984 14.9869 15.372 14.9869 16.0784C14.9869 16.7848 14.4133 17.3584 13.7069 17.3584C13.0005 17.3584 12.4269 16.7848 12.4269 16.0784C12.4269 15.372 13.0005 14.7984 13.7069 14.7984ZM15.4989 12.7503H15.7549C16.0944 12.7503 16.42 12.8853 16.66 13.1252C16.9 13.3652 17.0349 13.6909 17.0349 14.0303V14.5424H17.2909V13.7685C17.2909 13.4305 17.1566 13.1064 16.9177 12.8676C16.6789 12.6287 16.3547 12.4944 16.0168 12.4944H15.4989V12.7503Z"
      fill="#5F67E0"
    />
    <defs>
      <filter
        id="filter0_d_3621_2"
        x="0"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3621_2"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3621_2"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default NoDataScreen;
